import { Link } from "react-router-dom";

export default function HomeThreeAbout(){
    return(
        <section id="about" className="about-us-area pt-60 pb-90 pb-md-30 pb-xs-30">
			<div className="container">
				<div className="row justify-content-between">
					<div className="col-xl-8 pl-20 pl-lg-15 pl-md-15 pl-xs-15">
						<div className="founder-quote">
							<img className="mb-10" src="assets/img/about/about-7.jpg" alt="Image" />
							<div className="about-text-wrapper3 mb-30">
								<span>Since from 2000</span>
								<h2>Building Your Better IT Solution</h2>
								<p className="mb-45 pr-15">The definition of business is an occupation or trade
									&amp; the purchase and sale of products</p>
								<div className="cerficate-list-one d-sm-flex align-items-center">
									<img className="mr-30 mb-10" src="assets/img/about/about-5.jpg" alt="image" />
									<img className="mb-10" src="assets/img/about/about-6.jpg" alt="image" />
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4">
						<div className="approch-quote">
							<div className="approch-top-item">
								<span className="title">Our Mission &amp; Vision</span>
								<p>Voice and Data System are crucial
									to the success</p>
									<div className="layer-img"><img src="assets/img/layers/approch-item-bg.png" alt="" /></div>
							</div>
							<div className="approch-card">
								<span className="approch-card-title">Company Approch</span>
								<p>System is a term used to refer to
									an organized collection symbols
									&amp; processes that may be used to
									operate on such symbols.</p>
								<Link className="approch-readmore" to="about">Read more</Link>
								<div className="layer-img"><img src="assets/img/layers/approch-card-layer.png" alt="" /></div>
							</div>/
						</div>
					</div>
				</div>
			</div>
		</section>
    )
}